export default "__VITE_ASSET__CXD4MWbY__"